import React from "react";

function BoxIcon() {
  return (
    <svg
      width="38"
      height="42"
      viewBox="0 0 38 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0016 40.4599C17.6097 40.811 18.2996 40.9958 19.0018 40.9958C19.704 40.9958 20.3939 40.811 21.002 40.4599L35.0034 32.4591C35.611 32.1083 36.1156 31.6039 36.4666 30.9966C36.8177 30.3892 37.0029 29.7002 37.0036 28.9987V12.9971C37.0029 12.2956 36.8177 11.6066 36.4666 10.9992C36.1156 10.3919 35.611 9.88752 35.0034 9.53676L21.002 1.53595C20.3939 1.18484 19.704 1 19.0018 1C18.2996 1 17.6097 1.18484 17.0016 1.53595L3.0002 9.53676C2.39267 9.88752 1.88805 10.3919 1.53698 10.9992C1.1859 11.6066 1.00072 12.2956 1 12.9971V28.9987C1.00072 29.7002 1.1859 30.3892 1.53698 30.9966C1.88805 31.6039 2.39267 32.1083 3.0002 32.4591L17.0016 40.4599Z"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0017 40.9981V20.9961"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.58032 10.9922L19.0021 20.9932L36.4238 10.9922"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.001 5.53516L28.0028 15.8362"
        stroke="#667085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default BoxIcon;
